const $$splitComponentImporter = () => import('/app/src/routes/signup.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/signup")({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});